import { render } from "./LiveChallengeBoard.vue?vue&type=template&id=4b8e4d24&scoped=true"
import script from "./LiveChallengeBoard.vue?vue&type=script&lang=js"
export * from "./LiveChallengeBoard.vue?vue&type=script&lang=js"

import "./LiveChallengeBoard.vue?vue&type=style&index=0&id=4b8e4d24&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8e4d24"]])

export default __exports__